import React, { useState } from "react";
import Typography from "@mui/material/Typography";
import darkTheme from '../../src/theme';
import parse from "html-react-parser";
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import Box from '@mui/material/Box'

const termsCard = {
    borderTop: `1px dotted`,
    borderColor: `#2F2F2F`,
    marginTop: darkTheme.spacing(2),
    marginBottom: darkTheme.spacing(1),
    '& h5': {
        fontSize: 14,
        textTransform: 'capitalize',    
        color: darkTheme.palette.primary.dates,       
        fontWeight: 400,    
    },
    '& h6': {
        fontSize: 16,
        color: darkTheme.palette.primary.location,
        fontWeight: 400,    
    },   
};
const accordian = {
    background: 'none',
    boxShadow: 'none',
}; 
const accordianSummary = {
    fontSize: 14,
    color: darkTheme.palette.primary.location,
    fontWeight: 500,
    padding: 0,    
    '& a': {
        fontSize: 14,
        color: darkTheme.palette.primary.location,
        textDecoration:'underline'
    },
    '& span': {
        fontSize: 14,
        fontWeight: 100,
    },
    '& h5': {
        fontSize: 14,
        fontWeight: 100,
    },
    '& h6': {
        fontSize: 14,
        fontWeight: 100,
    },
    '& p': {
        fontSize: 14,
        fontWeight: 100,
    },
    '& ul': {
        fontSize: 14,
        fontWeight: 100,
        pl:2,
    },
};

function Terms({ data }) {  
    
  return (
    <>            
        {data.tc.length > 0 ? (
            <Typography component="div" sx={termsCard}>                                  
                <Accordion sx={accordian}>
                    <AccordionSummary
                          expandIcon={
                              <Box
                                sx={{
                                '.Mui-expanded & > .collapsIconWrapper': {
                                    display: 'none',
                                },
                                '.expandIconWrapper': {
                                    display: 'none',
                                },
                                '.Mui-expanded & > .expandIconWrapper': {
                                    display: 'block',
                                },
                                }}
                            >
                                <div className="expandIconWrapper">
                                      <RemoveIcon sx={{fontSize:16, color: darkTheme.palette.primary.location}} />
                                </div>
                                <div className="collapsIconWrapper">
                                    <AddIcon sx={{fontSize:16, color: darkTheme.palette.primary.location}} />
                                </div>
                            </Box>
                        }
                        aria-controls="panel1a-content"
                        id="panel1a-header"
                        sx={{ px: 0 }}
                        // classes={{ content: classes.content, expanded: classes.expanded }}                        
                    >
                        <Typography component="h5">Terms</Typography>
                    </AccordionSummary>
                        <AccordionDetails sx={accordianSummary}>
                          {parse(data.tc)} 
                        </AccordionDetails>
                </Accordion>
            </Typography>
        ) : ('')} 
    </>
  );
}

export default Terms;
